<ion-grid>
  <ion-row class="ion-align-items-center">
    <ion-col><h2 style="margin:8px">Ügytípusok</h2></ion-col>
    <ion-col size="auto">
      <ion-button (click)="uj()"><ion-icon slot="start" name="add"></ion-icon>Új ügytípus</ion-button>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-list lines="full">
  <ion-item *ngIf="fokategoriak.length === 0"><ion-label color="medium">Nincs ügytípus. Hozz létre egy főkategóriát (pl. „Büntető”, betűjel: B), majd alá alkategóriákat (pl. „Lopás”, betűjel: L → BL.1/{{ ev }}).</ion-label></ion-item>
  <ng-container *ngFor="let t of fokategoriak">
    <!-- Főkategória -->
    <ion-item>
      <ion-icon slot="start" name="folder" color="primary"></ion-icon>
      <ion-label>
        <h2>{{ t.nev }} <ion-badge *ngIf="t.elotag">{{ t.elotag }}</ion-badge> <ion-badge *ngIf="!t.aktiv" color="medium">inaktív</ion-badge></h2>
        <p>Főkategória · Ügyszám: {{ cimke(opciok.szamformatum, t.szamformatum) }}<span *ngIf="t.selejtezesi_ho"> · selejtezés: {{ t.selejtezesi_ho }} hó</span><span *ngIf="t.mappa"> · 📁 hibrid mappa ({{ t.mappa_struktura === 'gyujto' ? 'gyűjtő/ügy' : 'ügy' }})</span></p>
      </ion-label>
      <ion-button slot="end" fill="clear" color="success" title="Alkategória hozzáadása" (click)="ujAl(t)"><ion-icon name="add-circle"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" (click)="szerkeszt(t)"><ion-icon name="create"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" color="danger" (click)="torol(t)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
    <!-- Alkategóriák -->
    <ion-item *ngFor="let a of alkategoriak(t.id)" style="--padding-start: 36px;">
      <ion-icon slot="start" name="return-down-forward" color="medium"></ion-icon>
      <ion-label>
        <h3>{{ a.nev }} <ion-badge color="tertiary">{{ kombinaltBetujel(a) }}</ion-badge> <ion-badge *ngIf="!a.aktiv" color="medium">inaktív</ion-badge></h3>
        <p>betűjel: {{ a.elotag || '—' }} · ügyszám pl. <b>{{ kombinaltBetujel(a) }}.1/{{ ev }}</b></p>
      </ion-label>
      <ion-button slot="end" fill="clear" (click)="szerkeszt(a)"><ion-icon name="create"></ion-icon></ion-button>
      <ion-button slot="end" fill="clear" color="danger" (click)="torol(a)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ng-container>
</ion-list>

<ion-modal #tipusModal>
  <ng-template>
    <ion-header><ion-toolbar color="primary">
      <ion-title>{{ szerk?.id ? 'Ügytípus szerkesztése' : 'Új ügytípus' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="tipusModal.dismiss()">Mégse</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <ion-list>
        <ion-item><ion-input label="Megnevezés *" labelPlacement="stacked" [(ngModel)]="szerk.nev"></ion-input></ion-item>
        <ion-item>
          <ion-select label="Besorolás" labelPlacement="stacked" [(ngModel)]="szerk.szulo_id" interface="popover">
            <ion-select-option [value]="null">— Főkategória —</ion-select-option>
            <ion-select-option *ngFor="let f of szuloOpciok()" [value]="f.id">Alkategória ehhez: {{ f.nev }} ({{ f.elotag }})</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item><ion-input [label]="szerk.szulo_id ? 'Alkategória betűjele (pl. L)' : 'Betűjel (pl. P, C, B)'" labelPlacement="stacked" [(ngModel)]="szerk.elotag"></ion-input></ion-item>
        <ion-item lines="none" *ngIf="szerk.elotag || szerk.szulo_id">
          <ion-label color="medium">Eredő betűjel: <b>{{ kombinaltBetujel(szerk) || '—' }}</b> → pl. <b>{{ kombinaltBetujel(szerk) }}.1/{{ ev }}</b></ion-label>
        </ion-item>
        <ion-item>
          <ion-select label="Ügyszám-formátum" labelPlacement="stacked" [(ngModel)]="szerk.szamformatum" interface="popover">
            <ion-select-option *ngFor="let o of opciok.szamformatum" [value]="o.value">{{ o.label }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item><ion-input label="PMT-alapbesorolás" labelPlacement="stacked" [(ngModel)]="szerk.pmt_alap"></ion-input></ion-item>
        <ion-item><ion-input type="number" label="Selejtezési idő (hónap)" labelPlacement="stacked" [(ngModel)]="szerk.selejtezesi_ho"></ion-input></ion-item>
        <ion-item>
          <ion-checkbox slot="start" [(ngModel)]="szerk.aktiv"></ion-checkbox>
          <ion-label>Aktív</ion-label>
        </ion-item>
      </ion-list>

      <!-- Hibrid (helyi mappás) mód: az ügyek a megadott helyi mappa almappáiból olvasódnak be -->
      <ion-list-header><ion-label>Hibrid mappa (opcionális)</ion-label></ion-list-header>
      <ion-note class="ion-padding-start" color="medium">Ha megadsz egy helyi gyökérmappát, a hibrid szinkron ebből hozza létre az ügyeket (read-only). Üresen hagyva ez az ügytípus normál (online) marad.</ion-note>
      <ion-list>
        <ion-item>
          <ion-input label="Helyi gyökérmappa" labelPlacement="stacked" [(ngModel)]="szerk.mappa" (ionBlur)="mappaEllenoriz()" placeholder="pl. C:\Iroda\Bunteto"></ion-input>
          <ion-button *ngIf="desktop" slot="end" fill="clear" (click)="tallozMappa()" title="Tallózás…"><ion-icon name="folder-open"></ion-icon></ion-button>
          <ion-button slot="end" fill="clear" (click)="mappaEllenoriz()" title="Mappa ellenőrzése"><ion-icon name="search"></ion-icon></ion-button>
        </ion-item>
        <ion-item>
          <ion-select label="Mappastruktúra" labelPlacement="stacked" [(ngModel)]="szerk.mappa_struktura" (ionChange)="mappaEllenoriz()" interface="popover">
            <ion-select-option value="ugy">Minden almappa = egy ügy</ion-select-option>
            <ion-select-option value="gyujto">Almappa = gyűjtő (pl. cég), azon belül az ügyek (ha nincs, 1 ügy)</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item lines="none" *ngIf="mappaInfo">
          <ion-label class="ion-text-wrap" color="medium" *ngIf="mappaInfo.letezik">
            ✓ A mappa létezik · {{ mappaInfo.almappak }} almappa · becsült <b>{{ mappaInfo.ugyek_becsult }}</b> ügy
            <span *ngIf="mappaInfo.minta?.length"><br>pl. {{ mappaInfo.minta.join(', ') }}…</span>
          </ion-label>
          <ion-label color="danger" *ngIf="!mappaInfo.letezik">A mappa nem található a lemezen.</ion-label>
        </ion-item>
      </ion-list>

      <ion-button expand="block" (click)="mentes()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
